<template>
  <div class="home">
    <div class="detail-wrap" ref="reportContent" v-loading="loading">
      <!-- 基本信息 -->
      <el-form label-width="110px" class="detail-form">
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="活动编码：">{{ detail.actCode }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动名称：">{{ detail.actName }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动时间：">{{ activityTime }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="负责人编码：">{{
              detail.responseCode
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="负责人名称：">{{
              detail.responseName
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="负责人组织：">{{
              detail.responseOrgName
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分公司编码：">{{
              detail.responseBranchCode
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分公司名称：">{{
              detail.responseBranchName
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="兑付率：">{{
              detail.paymentRate
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="费用兑付比：">{{
              detail.feePaymentRatio
            }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 活动执行细则 -->
      <div class="block">
        <div class="block-title">活动执行细则</div>
        <el-input
          type="textarea"
          :rows="4"
          readonly
          resize="none"
          v-model="detail.executeDetail"
          placeholder="—"
        ></el-input>
      </div>

      <!-- 关联协议模板 -->
      <div class="block">
        <div class="block-title">关联协议模板</div>
        <el-table
          :data="detail.templateVos || []"
          border
          stripe
          size="small"
          class="report-table"
        >
          <el-table-column
            prop="agreeCode"
            label="协议模板编码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="agreeName"
            label="协议模板名称"
            align="center"
          ></el-table-column>
        </el-table>
      </div>

      <!-- 金额信息 -->
      <div class="block">
        <div class="block-title">金额信息</div>
        <el-row :gutter="16" class="amount-cards">
          <el-col :span="8">
            <div class="amount-card">
              <div class="amount-label">活动申请金额</div>
              <div class="amount-value black">￥{{ detail.appliedAmount || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="amount-card">
              <div class="amount-label">已发放金额</div>
              <div class="amount-value green">￥{{ detail.paidAmount || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="amount-card">
              <div class="amount-label">未发放金额（将退回）</div>
              <div class="amount-value red">
                ￥{{ detail.unpaidAmount || 0 }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 已发放奖励协议信息 -->
      <div class="block">
        <div class="block-title">
          已发放奖励协议信息（{{ (detail.paidShareVos || []).length }}条）
        </div>
        <el-table
          :data="detail.paidShareVos || []"
          border
          stripe
          size="small"
          class="report-table"
        >
          <el-table-column
            prop="agreeCode"
            label="协议编码"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="agreeName"
            label="协议名称"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="terminalCode"
            label="终端编码"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="terminalName"
            label="终端名称"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="amount"
            label="发放金额"
            align="center"
            min-width="100"
          ></el-table-column>
        </el-table>
      </div>

      <!-- 未发放奖励协议信息 -->
      <div class="block">
        <div class="block-title">
          未发放奖励协议信息（{{ (detail.unpaidShareVos || []).length }}条）
        </div>
        <el-table
          :data="detail.unpaidShareVos || []"
          border
          stripe
          size="small"
          class="report-table"
        >
          <el-table-column
            prop="agreeCode"
            label="协议编码"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="agreeName"
            label="协议名称"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="terminalCode"
            label="终端编码"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="terminalName"
            label="终端名称"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column label="扫码是否达标" align="center" min-width="100">
            <template slot-scope="scope">{{
              scope.row.scanCodePass === "Y" ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="taskPass"
            label="合格任务数量"
            align="center"
            min-width="110"
          ></el-table-column>
          <el-table-column
            prop="amount"
            label="退回金额（元）"
            align="center"
            min-width="100"
          ></el-table-column>
        </el-table>
      </div>

      <!-- 备注 -->
      <div class="note">注：未兑付终端，由分公司自行与终端协商处理。</div>
    </div>

    <!-- 结算报告附件上传 -->
    <div class="block report-block">
      <div class="block-title">结算报告</div>
      <Upload
        :value="reportFiles"
        @getFileList="onReportFileList"
        :disabled="true"
        accept=".pdf,.png,.jpg,.jpeg"
        fileMsg="点击「生成结算报告」自动生成"
      />
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-document"
        :loading="generating"
        @click="generateReport"
        v-if="!disabled"
        >生成结算报告</el-button
      >
      <el-button
        type="danger"
        size="small"
        icon="el-icon-close"
        @click="closeModal"
        v-if="showCancel"
        >关闭</el-button
      >
      <el-button
        type="primary"
        size="small"
        icon="el-icon-check"
        @click="confirmSettle"
        v-if="!disabled"
        >确认</el-button
      >
    </div>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import Storage from '@/found/utils/storage';
import Upload from '@/found/modules/upload/upload.vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
  name: 'detail',
  props: {
    formConfig: Object,
  },
  components: {
    Upload,
  },
  data() {
    return {
      loading: false,
      generating: false,
      detail: {},
      reportFiles: [],
      disabled: false,
      isSettled: false,
      showCancel: true,
    };
  },
  computed: {
    activityTime() {
      const { beginDate, endDate } = this.detail;
      if (!beginDate && !endDate) return '';
      return `${beginDate || ''}${beginDate && endDate ? ' - ' : ''}${
        endDate || ''
      }`;
    },
  },
  created() {
    this.getDetail();
    this.disabled = this.formConfig.disabled || (this.formConfig.row && this.formConfig.row.id);
    this.showCancel = !this.formConfig.row || !this.formConfig.row.id;
  },
  methods: {
    // 获取详情
    getDetail() {
      this.loading = true;
      request
        .post('/cps/cpsagreeztactreport/detail', {
          id: this.formConfig.id || this.formConfig.row.id,
        })
        .then((res) => {
          if (res.success) {
            this.detail = res.result || {};
            if (res.result.settlementUrl) {
              const urlStr = res.result.settlementUrl;
              const url = new URL(urlStr);
              const path = url.pathname.slice(1);
              this.reportFiles = [{
                fileName: `结算报告_${this.detail.actCode}.pdf`,
                url: urlStr,
                objectName: path,
              }] || [];
              console.log(this.reportFiles);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 生成结算报告：页面内容截图 -> PDF -> 上传
    async generateReport() {
      if (this.generating) return;
      this.generating = true;
      const loading = this.$loading({
        lock: true,
        text: '生成结算报告中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.6)',
      });
      try {
        const canvas = await html2canvas(this.$refs.reportContent, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#ffffff',
        });
        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        // eslint-disable-next-line new-cap
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageW = pdf.internal.pageSize.getWidth();
        const pageH = pdf.internal.pageSize.getHeight();
        const imgW = pageW;
        const imgH = (canvas.height * imgW) / canvas.width;
        let heightLeft = imgH;
        let position = 0;
        pdf.addImage(imgData, 'JPEG', 0, position, imgW, imgH);
        heightLeft -= pageH;
        while (heightLeft > 0) {
          position -= pageH;
          pdf.addPage();
          pdf.addImage(imgData, 'JPEG', 0, position, imgW, imgH);
          heightLeft -= pageH;
        }
        const blob = pdf.output('blob');
        const fileName = `结算报告_${this.detail.actCode}.pdf`;
        const file = new File([blob], fileName, { type: 'application/pdf' });
        const res = await this.uploadFile(file);
        if (res && res.success) {
          this.reportFiles = res.result || [];
          this.isSettled = true;
          this.$message.success('结算报告已生成');
          // this.submitUrl();
        } else {
          this.$message.error('结算报告上传失败');
        }
      } catch (e) {
        console.error(e);
        this.$message.error('生成结算报告失败');
      } finally {
        loading.close();
        this.generating = false;
      }
    },
    // submitUrl() {
    //   request
    //     .post('/cps/cpsagreeztactreport/update/settlementUrl', {
    //       id: this.formConfig.id,
    //       settlementUrl: this.reportFiles[0].url,
    //     })
    //     .then((res) => {
    //       if (res.success) {
    //         this.isSettled = true;
    //         this.$message.success('结算报告已生成');
    //       }
    //     });
    // },
    // 附件上传（参考 found/modules/upload，使用原生 XHR 以保证 multipart boundary 正确）
    uploadFile(file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file);
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/upload/uploadController/uploadOssList');
        xhr.setRequestHeader('loginUserToken', Storage.l.get('TokenKey'));
        xhr.onload = () => {
          if (xhr.status === 200) {
            try {
              resolve(JSON.parse(xhr.responseText));
            } catch (e) {
              reject(e);
            }
          } else {
            reject(new Error(`上传失败(${xhr.status})`));
          }
        };
        xhr.onerror = () => reject(new Error('上传失败'));
        xhr.send(formData);
      });
    },
    // 手动上传回调
    onReportFileList(list) {
      this.reportFiles = list || [];
    },
    // 确认结算
    confirmSettle() {
      if (!this.reportFiles || this.reportFiles.length === 0) {
        this.$message.warning('请先点击生成结算报告');
        return;
      }
      const amount = this.detail.unpaidAmount;
      const tip = `当前活动下存在【${amount}】未发放奖励，是否确认进行活动结算，活动结算后未发放金额将退回预算池中。`;
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.doSettle();
        })
        .catch(() => {});
    },
    // 发起结算
    doSettle() {
      if (!this.isSettled) {
        this.$message.warning('请先生成结算报告');
        return;
      }
      const params = {
        id: this.formConfig.id,
        settlementUrl: this.reportFiles[0].url,
      };
      const loading = this.$loading({
        lock: true,
        text: '结算中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.6)',
      });
      request
        .post('/cps/cpsagreeztactreport/initiateSettlement', params)
        .then((res) => {
          if (res.success) {
            this.$message.success('结算成功');
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    // 关闭弹窗
    closeModal() {
      this.$emit('onClose');
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  padding: 10px 16px;
  height: 100%;
  overflow-y: auto;
}
.detail-wrap {
  background: #fff;
  padding: 16px;
}
// 表格内容换行、不出现横向滚动，保证截图/PDF 能看到全部数据
.detail-wrap /deep/ .report-table {
  width: 100%;
  .el-table__body-wrapper {
    overflow-x: hidden;
  }
  .cell {
    white-space: normal;
    word-break: break-all;
    line-height: 1.5;
  }
}
.detail-form {
  .el-form-item {
    margin-bottom: 0;
  }
}
.block {
  margin-top: 18px;
}
.block-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  line-height: 16px;
}
.amount-cards {
  .amount-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 16px;
    text-align: center;
    .amount-label {
      color: #909399;
      font-size: 13px;
      margin-bottom: 8px;
    }
    .amount-value {
      font-size: 22px;
      font-weight: 600;
    }
    .black {
      color: #303133;
    }
    .green {
      color: #67c23a;
    }
    .red {
      color: #f56c6c;
    }
  }
}
.note {
  margin-top: 18px;
  color: #f56c6c;
  font-size: 13px;
}
.report-block {
  margin-top: 18px;
  margin-bottom: 60px;
}
.dialog-footer {
  text-align: right;
  margin-top: 16px;
  .el-button + .el-button {
    margin-left: 10px;
  }
}
</style>
